<template>
  <router-link :to="{ name: 'Contact', params: { id: local_contact.id } }">
    <div
        v-if="local_contact"
        class="contactPreviewCard"
        :class="{'inset': inset}"
    >
        <v-layout
            row
            wrap
        >
            <div
                v-if="!inset"
                style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
            >
                <v-icon>
                    {{ local_contact.is_active ? 'person' : 'mdi-account-off-outline' }}
                </v-icon>
            </div>
            <div>
                <b>{{ local_contact.full_name }}</b><br />
                <i>{{ local_contact.cuid }}</i><br />
                <span
                    v-if="local_contact.email"
                >
                    {{ local_contact.email }}<br />
                </span>
            </div>
        </v-layout>
    </div>
  </router-link>
</template>

<script>
import api from '@/api'

export default {
    name: 'ContactPreview',
    props: ['contact', 'id', 'inset'],
    data () {
      return {
        local_contact: null,
        searching: false
      }
    },
    created () {
        if (this.contact) {
            this.local_contact = JSON.parse(JSON.stringify(this.contact))
        } else {
            if (this.id)
                this.fetch()
        }
    },
    methods: {
        fetch () {
            this.searching = true
            api.userform.contact.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_contact = data
                })
        }
    }
}
</script>

<style scoped>
.contactPreviewCard {
    background:rgba(0,0,0,0.05);
    padding:5px;
    border-radius:5px;
    cursor:pointer;
}
.contactPreviewCard:hover {
    background:rgba(0,0,0,0.1);
}

.inset {
    background: unset;
    padding: unset !important;
}

.small-title {
    font-size: 12px !important;
    font-weight: 900 !important;
}

a {
    text-decoration: none;
    color: black;
}
</style>